import React, { useContext, useState } from 'react';
import ModalContext from '../../../context/ModalContext.js';
import AuthContext from '../../../context/AuthContext.js';
import { Button, CircularProgress } from '@mui/material';

const RevokeAdministratorModal = ({ modalDetails }) => {
  const modalCtx = useContext(ModalContext);
  const authCtx = useContext(AuthContext);
  const [revoking, setRevoking] = useState(false);

  const closeHandle = () => {
    modalCtx.closeModal();
  };

  const handleRevoke = () => {
    if (!modalDetails?.id) return;
    setRevoking(true);
    fetch(`${process.env.REACT_APP_API_URI}/v3/admin/administrators/${modalDetails.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + authCtx.token
      },
      body: JSON.stringify({ id: modalDetails.id, access: 'user' })
    })
      .then(res => res.json())
      .then(data => {
        setRevoking(false);
        if (data.status === 'success') {
          modalCtx.setPageUpdate({ page: 'Administrators' });
          modalCtx.closeModal();
        } else {
          alert('Failed to revoke administrator access.');
        }
      })
      .catch(() => {
        setRevoking(false);
        alert('Failed to revoke administrator access.');
      });
  };

  return (
    <div className="modal-container">
      <div className='modal-header'>
        <h1>Revoke Administrator Access</h1>
      </div>
      <div className="modal-body">
        <span>Are you sure you want to revoke the access?</span>
      </div>
      <div className="modal-footer">
        <Button className="cancel-btn" onClick={closeHandle} disabled={revoking}>CANCEL</Button>
        <Button onClick={handleRevoke} disabled={revoking} variant="contained">
          {revoking ? <CircularProgress size={16} style={{ color: "#fff" }} /> : ''} REVOKE
        </Button>
      </div>
    </div>
  );
};

export default RevokeAdministratorModal; 